import { MaladieService } from './../../../services/agenda/maladie.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { IMaladie } from 'app/views/agenda/interface/imaladie';
import { CodesService } from './../../../services/codes/codes.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-ajouter-maladie-dialog',
  templateUrl: './ajouter-maladie-dialog.component.html',
  styleUrls: ['./ajouter-maladie-dialog.component.scss']
})
export class AjouterMaladieDialogComponent implements OnInit {
  public maladies: IMaladie[] = [];
  public myInput;
  public isChecked: boolean = false;
  public displayInput: boolean = false;
  public hideDisplayInput: boolean = true;
  public valid: boolean = true;
  public isModification: boolean = false;
  @Output() chargerAgenda = new EventEmitter<any>();

  constructor(
    public dialogRef: MatDialogRef<AjouterMaladieDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _maladieService: MaladieService,
  ) { }

  ngOnInit() {
    if (this.data.choixPremMaladie === 0) {
      this.displayInput = true;
      this.hideDisplayInput = false;
    }
  }
  deleteSickness(cle: number) {
    this.data.operation = 3;
  }

  onFocus() {
    this.isChecked = true;
  }

  onChangePremMaladie(event: any) {
    if (event.value !== 0) {
      this.isChecked = false;
      this.displayInput = true;
      this.hideDisplayInput = true;
    }

    if (event.value === 0) {
      this.isChecked = true;
      this.displayInput = true;
      this.hideDisplayInput = false;
    }
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

}
